import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Upload, Circle } from 'lucide-react';
import { fetchDashStats, fetchDashActivity, DashStat, ActivityItem } from '../api';

export default function DashboardSection() {
  const [stats, setStats] = useState<DashStat[]>([]);
  const [activity, setActivity] = useState<ActivityItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    Promise.all([fetchDashStats(), fetchDashActivity(10)])
      .then(([s, a]) => {
        if (cancel) return;
        setStats(s); setActivity(a);
      })
      .finally(() => !cancel && setLoading(false));
    return () => { cancel = true; };
  }, []);

  return (
    <div className="max-w-[1180px] mx-auto" data-testid="dash-section">
      {/* Title */}
      <div className="mb-6">
        <h1 className="text-[24px] font-semibold text-[#1f1f1d] mb-1">Panoramica abbinatore</h1>
        <p className="text-[15px] text-[#6d6d68]">Stato della copertura di compatibilità e azioni rapide.</p>
      </div>

      {/* KPI cards */}
      <div className="grid grid-cols-5 gap-3 mb-6" data-testid="dash-kpis">
        {(loading ? Array(5).fill(null) : stats).map((s, i) => (
          <div key={i} className="bg-white border border-[#e2e2df] rounded-[11px] px-4 py-[15px]" data-testid={`kpi-${i}`}>
            <div className="text-[11px] font-bold tracking-[0.1em] text-[#5c5c57] font-mono mb-2.5">
              {s?.label ?? '…'}
            </div>
            <div className="text-[28px] font-semibold text-[#1f1f1d] leading-none">{s?.value ?? '—'}</div>
            <div className="text-[13px] text-[#5c5c57] mt-1.5">{s?.sub ?? ''}</div>
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <div className="flex gap-2.5 mb-6 flex-wrap">
        <Link to="/admin/abbinatore-v2/abbinamento" className="inline-flex items-center gap-2 px-4 py-[11px] rounded-[9px] bg-[#2b3a8f] text-white text-[15px] font-semibold hover:bg-[#243279] transition-colors" data-testid="action-new-match">
          <Plus className="w-3.5 h-3.5" /> Nuovo abbinamento
        </Link>
        <Link to="/admin/abbinatore-v2/import-export" className="inline-flex items-center gap-2 px-4 py-[11px] rounded-[9px] bg-white border border-[#cfcfca] text-[#3a3a36] text-[15px] font-semibold hover:bg-[#fafafa] transition-colors" data-testid="action-import-csv">
          <Upload className="w-3.5 h-3.5" /> Importa CSV
        </Link>
      </div>

      {/* Attività recente */}
      <div className="bg-white border border-[#e2e2df] rounded-[11px] overflow-hidden">
        <div className="px-4 py-3.5 border-b border-[#eee] text-[15px] font-semibold text-[#1f1f1d]">
          Attività recente
        </div>
        {loading ? (
          <div className="px-4 py-10 text-center text-[14px] text-[#5c5c57]">Caricamento…</div>
        ) : activity.length === 0 ? (
          <div className="px-4 py-10 text-center text-[14px] text-[#5c5c57]">
            Nessuna attività recente. Le modifiche dell'abbinatore appariranno qui.
          </div>
        ) : (
          activity.map((ev, i) => (
            <div key={i} className="flex gap-3 px-4 py-2.5 border-b border-[#f1f1ee] last:border-0">
              <Circle className="w-1.5 h-1.5 mt-2 fill-[#c4c4c1] text-[#5c5c57] flex-none" />
              <div className="flex-1">
                <div className="text-[15px] text-[#3a3a36]">{ev.text}</div>
                <div className="text-[13px] font-mono text-[#5c5c57] mt-0.5">{ev.meta}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
